import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App.jsx";
import { ConfigProvider, theme } from "antd";
import { ThemeProvider, useTheme } from "./context/ThemeContext";
import { CapacitorUpdater } from "@capgo/capacitor-updater";
import PWAInstallPrompt from "./components/PWAInstallPrompt";
import { setupSyncListeners } from "./services/syncService";

const Root = () => {
  const { isDark } = useTheme();

  React.useEffect(() => {
    // Notify Capgo that the app is ready
    CapacitorUpdater.notifyAppReady();
  }, []);

  return (
    <ConfigProvider
      theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
        token: {
          colorPrimary: "#1677ff",
        },
      }}
    >
      <div
        style={{
          minHeight: "100vh",
          width: "100%",
          margin: 0,
          padding: 0,
          backgroundColor: isDark ? "#141414" : "#ffffff",
        }}
      >
        <App />
      </div>
    </ConfigProvider>
  );
};

const AppWithProviders = () => {
  React.useEffect(() => {
    // Register service worker in both development and production for PWA testing
    if ("serviceWorker" in navigator) {
      window.addEventListener("load", () => {
        navigator.serviceWorker
          .register("/sw.js")
          .then((registration) => {
            
            // Set up periodic updates
            setInterval(() => {
              registration.update();
            }, 60 * 60 * 1000); // Check every hour
            
            // Request notification permission for PWA features
            if ("Notification" in window && Notification.permission === "default") {
              Notification.requestPermission().then(permission => {
              });
            }
            
            // Set up background sync
            if ('sync' in registration) {
            } else {
            }
          })
          .catch((registrationError) => {
          });
      });
    }
    
    // Set up sync listeners for offline functionality
    setupSyncListeners();
    
    // Log PWA capabilities
  }, []);

  return (
    <ThemeProvider>
      <Root />
      <PWAInstallPrompt />
    </ThemeProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(
  <AppWithProviders />
);
